import axios from 'axios'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import { auth } from '@configs/firebase'
import Cookies from 'js-cookie'

const AxiosClient = axios.create()
AxiosClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const tokenId = await auth.currentUser?.getIdToken(true)
        if (tokenId) {
          Cookies.set(AUTH_TOKEN_KEY, tokenId)
          // Retry the original request with the new token
          if (tokenId) {
            originalRequest.headers.Authorization = `Bearer ${tokenId}`
            return AxiosClient(originalRequest)
          }
        } else {
          Promise.reject(error)
        }
      } catch (refreshError) {
        console.error('Error refreshing token:', refreshError)
      }
    }
    return Promise.reject(error)
  }
)

export default AxiosClient
